<template>
	<div class="order-detail">
		<div
			v-for="(product, index) in products"
			:key="product.id"
			class="order-row"
		>
			<div class="order-col order-name">
				<span class="order-index" :style="`color:${globalColors.primary}`">{{ index + 1 }}-</span> {{ product.productName }}
			</div>
			<div class="order-col">
				Cantidad: {{ product.quantity }}
			</div>
			<div class="order-col order-amount">
				{{ product.currencySymbol }} {{ product.total }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'order-detail',
		props: {
			products: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.order {
		&-detail {
			border: 1px solid color(borderThum);
			border-radius: 8px;
			margin-right: 11px; 
			max-width: calc(100% - 294px);
			min-height: 185px;
			padding: 27px 55px;
			width: 100%;
		}

		&-row {
			align-items: center;
			border-bottom: 1px solid color(borderThum);
			display: flex;
			justify-content: space-between;
			padding-bottom: 15px;
			padding-top: 15px;

			&:first-child {
				padding-top: 0px;
			}

			&:last-child {
				border-bottom: 0px;
				padding-bottom: 0px;
			}
		}

		&-col {
			font-size: size(msmall);
		}

		&-index {
			font-family: font(avenirBold);
			font-size: size(medium);
		}

		&-name {
			font-family: font(avenirDemi);
			font-size: size(medium);
		}

		&-amount {
			color: color(redBold);
			font-family: font(open-bold);
			font-size: size(normal);
			letter-spacing: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// order-detail.vue?0580ddd0